  <div *ngFor="let error of this.errors" class="error-box">
    <div class="error-box-item">{{error.message}}</div>
  </div>
